__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "@mysky/app_shell";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@core-ui/feature-toggles", "4.0.2", () => (Promise.all([__webpack_require__.e(644), __webpack_require__.e(572), __webpack_require__.e(96), __webpack_require__.e(307)]).then(() => (() => (__webpack_require__(30509))))));
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(678), __webpack_require__.e(593), __webpack_require__.e(96), __webpack_require__.e(688)]).then(() => (() => (__webpack_require__(54158))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(678), __webpack_require__.e(96), __webpack_require__.e(267)]).then(() => (() => (__webpack_require__(71479))))));
			register("@mui/material", "5.18.0", () => (Promise.all([__webpack_require__.e(644), __webpack_require__.e(678), __webpack_require__.e(593), __webpack_require__.e(96), __webpack_require__.e(32)]).then(() => (() => (__webpack_require__(37267))))));
			register("@sentry/browser", "11.3.0", () => (__webpack_require__.e(895).then(() => (() => (__webpack_require__(71339))))));
			register("axios", "1.20.0", () => (__webpack_require__.e(895).then(() => (() => (__webpack_require__(772))))));
			register("react-dom", "19.2.6", () => (Promise.all([__webpack_require__.e(644), __webpack_require__.e(545)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(593), __webpack_require__.e(96), __webpack_require__.e(926)]).then(() => (() => (__webpack_require__(71468))))));
			register("react", "19.2.6", () => (__webpack_require__.e(644).then(() => (() => (__webpack_require__(96540))))));
			register("redux-actions", "2.6.5", () => (Promise.all([__webpack_require__.e(593), __webpack_require__.e(96)]).then(() => (() => (__webpack_require__(84560))))));
			register("redux-saga", "1.2.3", () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(6986))))));
			register("redux", "4.2.0", () => (Promise.all([__webpack_require__.e(593), __webpack_require__.e(96)]).then(() => (() => (__webpack_require__(82960))))));
			register("reselect", "5.1.1", () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(25508))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};